var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-space-x"},[_c('v-switch',{attrs:{"label":("" + (_vm.switch1.toString())),"hide-details":""},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }